import React from "react";
import { useNavigate } from "react-router-dom";
import PageNotFoundImage from "../assets/admin/pageNotFound.svg";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex items-center justify-center min-h-screen mx-auto">
      <div className="text-center space-y-8">
        <img
          src={PageNotFoundImage}
          alt="Bereload PageNotFound"
          className="mx-auto"
        />
        <div className="space-y-1">
          <h2 className="text-5xl leading-none font-extrabold tracking-tight">
            Page not found
          </h2>
          <p className="text-base leading-6 font-normal text-gray-500">
            It looks like the page you’re looking for doesn’t exist or has been
            moved.
          </p>
        </div>
        <div className="mt-10 flex gap-3 justify-center">
          <button
            className="px-4 py-2 rounded-md bg-primary text-text1"
            onClick={handleBackHome}
          >
            Go back home
          </button>
          <button className="px-4 py-2 rounded-md border border-text1">
            Contact support
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
